import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { DataService } from '../../services/data.service';
am4core.useTheme(am4themes_animated);
import { Subscription} from 'rxjs';

@Component({
  selector: 'app-incident-chart',
  templateUrl: './incident-chart.component.html',
  styleUrls: ['./incident-chart.component.scss']
})
export class IncidentChartComponent implements OnInit, OnDestroy {
  private chart: am4charts.XYChart;
  observable: Subscription;
  statesValues: any;
  incidentData: any;
  refreshChart: any;
  month: any;
  constructor(private dataService: DataService, private zone: NgZone) {
    this.refreshChart = false;
  }
  ngOnInit() {
    this.observable = this.dataService.message.subscribe( data => { this.loadData(data); });
  }
  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
        this.observable.unsubscribe();
      }
    });
  }
  loadData(data) {
    this.statesValues = data['value'];
    this.refreshChart = data['remove'];
    if (this.refreshChart === true) {
      this.removeSeries();
    }
      this.loadChart();
  }
  loadChart() {
    this.incidentData = [['25', '23', '27', '18', '19', '17', '31', '20', '17', '37', '45', '35', '31', '34', '32', '47', '44', '24', '25', '28', '36', '27', '33', '29', '31', '25', '32', '38' ],
    ['42', '32', '45', '32', '19', '43', '61', '58', '44', '33', '29', '32', '36', '35', '46', '35', '46', '37', '58', '50', '52', '29', '64', '55', '78', '47', '28', '14', '59', '67', '37', '34', '28']];
    // this.incidentData = [['18', '28', '13', '24', '16', '20', '10', '17', '13', '10', '10', '20', '16', '18', '16', '16', '26', '15', '10', '14',
    //   '19', '20', '19', '17', '18', '17', '14', '38'],
    //   ['19', '11', '18', '12', '7', '17', '25', '22', '17', '24', '9', '19', '21', '19', '15', '16', '15', '18', '23', '18', '19', '14', '13', '24', '24', '10', '11', '13', '15', '11', '21', '20']];
    this.month = [1, 2];
    this.chart = am4core.create('incidentchartdiv', am4charts.XYChart);
    this.chart.paddingRight = 20;

    let data = [];
    let visits = 10;
    let previousValue;
    for ( let i = 0; i < 30; i++) {
      visits = this.incidentData[this.statesValues][i];
      if (i > 0) {
        // add color to previous data item depending on whether current value is less or more than previous value
        if (previousValue <= visits) {
          data[i - 1].color = this.chart.colors.getIndex(0);
        } else {
          data[i - 1].color = this.chart.colors.getIndex(5);
        }
      }

      data.push({ date: new Date(2015, this.month[this.statesValues], i + 1), value: visits });
      previousValue = visits;
    }

    this.chart.data = data;

    const dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.renderer.axisFills.template.disabled = true;
    dateAxis.renderer.ticks.template.disabled = true;

    const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;
    valueAxis.renderer.axisFills.template.disabled = true;
    valueAxis.renderer.ticks.template.disabled = true;

    const series = this.chart.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = 'date';
    series.dataFields.valueY = 'value';
    series.strokeWidth = 2;
    series.tooltipText = 'incidents: {valueY}, change: {valueY.previousChange}';

// set stroke property field
    series.propertyFields.stroke = 'color';

    this.chart.cursor = new am4charts.XYCursor();

  }
  removeSeries() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
}
